let documents = []
let listeners = []

export default {
  init () {
    const sessionDocuments = localStorage.getItem('documents')
    if (sessionDocuments) {
      documents = JSON.parse(sessionDocuments)
    }
  },

  add (item) {
    if (typeof item === 'object' && item.constructor === Object && item.id && item.title) {
      if (!this.has(item.id)) {
        documents.push(item)
        this.sessionUpdate()
        listeners.forEach(cb => cb(documents))
      }
    }
  },

  addListener (callback) {
    if (typeof callback === 'function') {
      listeners.push(callback)
    }
  },

  clear () {
    localStorage.removeItem('documents')
    documents = []
    listeners.forEach(cb => cb(documents))
  },

  get () {
    // return cloned array
    return documents.map(item => item)
  },

  has (id) {
    return !!documents.filter(item => item.id === id)[0]
  },

  remove (id) {
    if (this.has(id)) {
      const index = documents.indexOf(documents.find(item => item.id === id))
      documents.splice(index, 1)
      this.sessionUpdate()
      listeners.forEach(cb => cb(documents))
    }
  },

  removeListener (callback) {
    const index = listeners.indexOf(callback)
    if (index >= 0) {
      listeners.splice(index, 1)
    }
  },

  sessionUpdate () {
    localStorage.setItem('documents', JSON.stringify(documents))
    document.dispatchEvent(new CustomEvent('sessionDocuments.update', { detail: { documents } }))
  }
}
